module.exports = new __parcel__URL__("card-layout-app-skeleton.tpl.6c555b33.svg").toString();